"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const flightHandlers_1 = require("../../handlers/flightHandlers");
const react_redux_1 = require("react-redux");
const selectors_1 = require("../../store/redux/selectors");
const FlightOverviewWeb_1 = __importDefault(require("../common/FlightOverviewWeb"));
const lodash_1 = require("lodash");
const native_1 = require("@react-navigation/native");
const react_i18next_1 = require("react-i18next");
const PaginationNavigation_1 = __importDefault(require("../common/PaginationNavigation"));
const RequestOverviewWeb_1 = __importDefault(require("../common/RequestOverviewWeb"));
const FlightsNearYouWeb = () => {
    const asAPilot = (0, react_redux_1.useSelector)(selectors_1.getAsAPilot);
    const { timeZone } = Intl.DateTimeFormat().resolvedOptions();
    (0, native_1.useFocusEffect)((0, react_1.useCallback)(() => {
        (0, flightHandlers_1.getNearbyFlightsHandler)(asAPilot, timeZone);
    }, [asAPilot]));
    const [cardNumber, setCardNumber] = (0, react_1.useState)(0);
    const nearbyFlights = (0, react_redux_1.useSelector)(selectors_1.getFlights);
    const navigation = (0, native_1.useNavigation)();
    const [t] = (0, react_i18next_1.useTranslation)("i18n", { keyPrefix: 'flights_nearby' });
    const flightCards = (0, lodash_1.range)(0, nearbyFlights.length);
    return (0, lodash_1.isEmpty)(nearbyFlights) ?
        (0, jsx_runtime_1.jsx)("div", {}) :
        (0, jsx_runtime_1.jsxs)("div", { className: "flights-nearby", children: [(0, jsx_runtime_1.jsx)("span", { className: "nearby-title", children: t(asAPilot ? "incoming_requests" : "incoming_flights") }), nearbyFlights[cardNumber].request ?
                    (0, jsx_runtime_1.jsx)(RequestOverviewWeb_1.default, { flightData: nearbyFlights[cardNumber], navigate: () => navigation.navigate("RequestDetails", { id: nearbyFlights[cardNumber].id }) }) :
                    (0, jsx_runtime_1.jsx)(FlightOverviewWeb_1.default, { flightData: nearbyFlights[cardNumber], navigate: () => navigation.navigate("FlightDetails", { id: nearbyFlights[cardNumber].id }) }), (0, jsx_runtime_1.jsx)(PaginationNavigation_1.default, { pageNumber: cardNumber, setPageNumber: setCardNumber, pages: flightCards })] });
};
exports.default = FlightsNearYouWeb;
